import { AuthContext, User } from "Auth";
import Template from "components/Template/Template";
import Verify from "./Verify";
import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

function Root() {
    // Get Auth Context
    const user: User = useContext(AuthContext);

    if (!user.isAuthenticated) {
        return <Navigate to="/login" replace />
    }

    return (
        <div className="w-full h-full App">
            <Template childrentFooter={null}>
                {user.verified ? <Outlet /> : <Verify />}
            </Template>
        </div>
    );
}

export default Root;
